/**
 * SLA threshold values used in routing policies
 */
export const SLA_THRESHOLDS = {
  SIGNATURE: '10',
  PRIORITY: '30',
  ESSENTIALS_PLUS: '60',
  DEFAULT: 'default',
} as const;

export const SLA_THRESHOLD_LABELS: Record<string, string> = {
  [SLA_THRESHOLDS.DEFAULT]: 'Default',
  [SLA_THRESHOLDS.ESSENTIALS_PLUS]: 'Essentials Plus',
  [SLA_THRESHOLDS.PRIORITY]: 'Priority/Proactive',
  [SLA_THRESHOLDS.SIGNATURE]: 'Signature',
};

/**
 * Ordered list of SLA thresholds for display (Default at top, Signature at bottom)
 */
export const ORDERED_SLA_THRESHOLDS = [
  SLA_THRESHOLDS.DEFAULT,
  SLA_THRESHOLDS.ESSENTIALS_PLUS,
  SLA_THRESHOLDS.PRIORITY,
  SLA_THRESHOLDS.SIGNATURE,
];

export type VoiceRoutingAction = 'route_to_provision' | 'connect_to_partner';

export type SlaThresholdMap = Record<string, string | null>;

export interface TimeBasedRoutingMap {
  during_business_hours?: SlaThresholdMap;
  after_business_hours?: SlaThresholdMap;
}

export interface EmailChannelPolicy {
  support?: TimeBasedRoutingMap;
  membership?: TimeBasedRoutingMap;
}

export interface SlaRoutingPolicy {
  email?: EmailChannelPolicy;
  voice?: TimeBasedRoutingMap;
}
